import { render, staticRenderFns } from "./ItemsClassTable.vue?vue&type=template&id=58e34fbf&scoped=true&"
import script from "./ItemsClassTable.vue?vue&type=script&lang=js&"
export * from "./ItemsClassTable.vue?vue&type=script&lang=js&"
import style0 from "./ItemsClassTable.vue?vue&type=style&index=0&id=58e34fbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e34fbf",
  null
  
)

export default component.exports